import React from "react";
import { View, StyleSheet, ViewStyle } from "react-native";

interface AdminTableProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

const AdminTable: React.FC<AdminTableProps> = ({ children, style }) => {
  return <View style={[styles.container, style]}>{children}</View>;
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    borderRadius: 8,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#E5E7EB",
  },
});

export default AdminTable;
